module.exports = __webpack_public_path__ + "img/midlandautosales-leicester-aa-warranty2.74a687dd.jpg";